import{createContext as r}from"react";var t={id:"default-id"},a=r(t);export{a as DialogBoxContext,t as defaultValues};
